const extractPackageEvent = require('./getEvents/extractPackageEvent');
const negotiateSetLastConfirmed = require('./getEvents/negotiateSetLastConfirmed');
const flatMap = require('lodash.flatmap');

//TODO TEST
module.exports = function getPackageEvents(packageEvents) {
    var result = flatMap(packageEvents, extractPackageEvent);
    negotiateSetLastConfirmed(result);
    return result;
};
